module.exports = __webpack_public_path__ + "img/b_s_3.4588407a.png";